$('.toggler-downloadcenter').on('click', function() {
    $(this).find('.toggler-icon-downloadcenter').toggleClass('active');
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/downloadcenter.js
// module id = 29
// module chunks = 0